// The platform login (role superadmin) manages companies and works in none (owner's
// request): Manage Companies is its one page, with no other menu, no company switcher
// and no company tools around it. Everyone else is unaffected.
export const PLATFORM_HOME = '/admin/new-company';

export function isPlatformAccount(user: { roles?: string[] | null } | null | undefined): boolean {
  return !!user?.roles?.includes('superadmin');
}
